import styled from "styled-components";

export const GlobalWrap = styled.div``;

export const PlayerTable = styled.div``;

export const Club = styled.div`
  h2 {
    opacity: 1;
    color: ${(props) => props.theme.white};
    font-family: "SatoshiBold";
    font-size: 16px;
    font-weight: 700;
    font-style: Bold;
    letter-spacing: 0px;
    text-align: left;
    line-height: 24px;
    margin-left: 20px;
  }
`;

export const PlayerStatsScrollContainer = styled.div`
  position: relative;
  max-height: 65vh;
  overflow: auto;
  -ms-overflow-style: auto;
  scrollbar-width: auto;
`;

export const PlayerStatsSingleTable = styled.table`
  width: max-content;
  min-width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;

  .react-tooltip {
    background: #cfdae6;
    opacity: 1;
    color: rgba(4, 8, 2, 1);
    font-family: "SatoshiBold";
    font-size: 16px;
    font-weight: 700;
    font-style: Bold;
    letter-spacing: 0px;
    text-align: center;
    line-height: 24px;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 3;
    background: ${(props) => props.theme.black};
    opacity: 1;
    color: rgba(115, 128, 137, 1);
    font-family: "SatoshiMedium";
    font-size: 12px;
    font-weight: 500;
    font-style: Medium;
    letter-spacing: 0.5px;
    text-align: center;
    line-height: 18px;
    padding: 14px 10px;
    white-space: nowrap;
  }

  thead th.playerColumn {
    left: 0;
    z-index: 5;
    padding: 14px 20px;
    text-align: left;
  }

  thead th.statColumn {
    min-width: 76px;
    width: 76px;
    max-width: 76px;
  }

  thead th.sortable {
    cursor: pointer;
  }

  tbody tr:nth-child(odd) td {
    background: ${(props) => props.theme.black};
  }

  tbody tr:nth-child(even) td {
    background: ${(props) => props.theme.row};
  }

  tbody td {
    height: 60px;
    padding: 0 10px;
    white-space: nowrap;
    vertical-align: middle;
    text-align: center;
    opacity: 1;
    color: ${(props) => props.theme.white};
    font-family: "SatoshiMedium";
    font-size: 16px;
    font-weight: 500;
    font-style: Medium;
    letter-spacing: 0px;
    line-height: 24px;
  }

  tbody td.playerColumn {
    position: sticky;
    left: 0;
    z-index: 2;
    padding: 0 20px;
  }

  tbody td.statColumn {
    min-width: 76px;
    width: 76px;
    max-width: 76px;
  }

  thead th.playerColumn,
  tbody td.playerColumn {
    min-width: 470px;
    width: 470px;
    max-width: 470px;
    box-sizing: border-box;
  }
`;

export const PlayerColumnHeaderContent = styled.div`
  display: grid;
  grid-template-columns: 92px 60px minmax(0, 1fr) 80px;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

export const PlayerColumnRowContent = styled.div`
  display: grid;
  grid-template-columns: 92px 60px minmax(0, 1fr) 80px;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

export const PlayerMediaPlaceholder = styled.div`
  width: 92px;
`;

export const PlayerMediaContent = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  min-width: 92px;
`;

export const PlayerFavoriteIcon = styled.img`
  width: 18px;
  height: 18px;
  cursor: pointer;
  flex-shrink: 0;
`;

export const PlayerPhoto = styled.img`
  width: 40px;
  height: 40px;
  object-fit: contain;
  flex-shrink: 0;
`;

export const PlayerNumberText = styled.span`
  opacity: 1;
  color: ${(props) => props.theme.white};
  font-family: "SatoshiMedium";
  font-size: 16px;
  font-weight: 500;
  font-style: Medium;
  letter-spacing: 0px;
  line-height: 24px;
`;

export const PlayerNameText = styled.span`
  display: block;
  opacity: 1;
  color: ${(props) => props.theme.white};
  font-family: "SatoshiMedium";
  font-size: 16px;
  font-weight: 500;
  font-style: Medium;
  letter-spacing: 0px;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const PlayerPositionText = styled.span`
  opacity: 1;
  color: ${(props) => props.theme.white};
  font-family: "SatoshiMedium";
  font-size: 16px;
  font-weight: 500;
  font-style: Medium;
  letter-spacing: 0px;
  line-height: 24px;
`;

export const HeaderLabelText = styled.span`
  opacity: 1;
  color: rgba(115, 128, 137, 1);
  font-family: "SatoshiMedium";
  font-size: 12px;
  font-weight: 500;
  font-style: Medium;
  letter-spacing: 0.5px;
  line-height: 18px;
`;

export const StatHeaderLabel = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

export const PlayerStatsLoadingState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  width: 100%;
`;
